import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.open_dialog_view_file,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.open_dialog_view_file) = $event)),
    title: "Visor de archivos",
    draggable: "",
    top: "2vh"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-custom btn-danger btn-sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open_dialog_view_file = false))
        }, " Cerrar ")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("embed", {
        src: _ctx.serverFile + _ctx.urlFile,
        type: "application/pdf",
        width: "100%",
        height: "500px"
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}